import styled from 'styled-components'
import { FontWeight } from '../../../shared/constants'

export const PageTitle = styled('h3')`
  font-size: 24px;
  font-weight: ${FontWeight.medium};
  text-align: center;
  margin-bottom: 1rem;
`
